import { get, merge, cloneDeep } from 'lodash';
import { getContentsWithLandingPage, getMediaTypes } from '@/modules/content/config';
import RelationCard from '@/modules/relation/card/form/RelationCardForm.vue';
import RelationCardWithClipping
  from '@/modules/relation/card/form/RelationCardWithClippingForm.vue';
import RelationImage from '@/modules/relation/card/form/RelationImageForm.vue';
import RelationMultimediaCard from '@/modules/relation/card/form/RelationMultimediaCardForm.vue';
import RelationPhotogalleryCard
  from '@/modules/relation/card/form/RelationPhotogalleryCardForm.vue';
import RelationContentCard from '@/modules/relation/card/form/RelationContentCard.vue';
import ConfigGeneratedCardForm from '@/modules/relation/card/form/ConfigGeneratedCardForm.vue';


/** Typescript definitions */
interface INxRelationshipCardConfig {
    cardComponent: Object,
    cardParams: {
        [k: string]: any,
    },
}

interface INxRelationshipEditorDefinition {
    [k: string]: INxRelationshipCardConfig
}

interface INxRelationshipEditorConfig extends INxRelationshipCardConfig {
    relationType: string,
    types: string[] | null,
}

type TGetConfig = (relationType: string, cardParams: object, types: string[]) => INxRelationshipEditorConfig;


const definition: INxRelationshipEditorDefinition = {
  default: {
    cardComponent: RelationCard,
    cardParams: {
      aspectRatios: ['16-9-aspect-ratio', '21-9-aspect-ratio', '8-9-aspect-ratio'],
    },
  },
  relationMoreInfo: {
    cardComponent: RelationCard,
    cardParams: {
      aspectRatios: ['16-9-aspect-ratio', '21-9-aspect-ratio'],
      types: getContentsWithLandingPage(),
    },
  },
  relationMultimedia: {
    cardComponent: RelationMultimediaCard,
    cardParams: {
      aspectRatios: ['16-9-aspect-ratio', '21-9-aspect-ratio'],
      types: getMediaTypes(),
    },
  },
  relationPhotogallery: {
    cardComponent: RelationPhotogalleryCard,
    cardParams: {
      aspectRatios: ['16-9-aspect-ratio'],
      types: ['image'],
    },
  },
  relationImage: {
    cardComponent: RelationImage,
    cardParams: {
      aspectRatios: ['16-9-aspect-ratio', '21-9-aspect-ratio'],
      types: ['image'],
    },
  },
  relationTwitter: {
    cardComponent: RelationCardWithClipping,
    cardParams: {
      aspectRatios: ['16-9-aspect-ratio'],
      types: ['image'],
    },
  },
  relationOg: {
    cardComponent: RelationCardWithClipping,
    cardParams: {
      aspectRatios: ['16-9-aspect-ratio'],
      types: ['image'],
    },
  },
  relationContent: {
    cardComponent: RelationContentCard,
    cardParams: {
      aspectRatios: ['16-9-aspect-ratio'],
      types: getContentsWithLandingPage(),
      clippingTypes: getMediaTypes(),
    },
  },
  configGenerated: {
    cardComponent: ConfigGeneratedCardForm,
    cardParams: {},
  },
};
/**
 * Returns the configurantion for the given relation type.
 * Additionally, merges the given cardParms and types into the configuration.
 *
 * @param {String} relationType
 * @param {Object} cardParams
 * @param {Array}  types
 */
export const getConfig: TGetConfig = (relationType = 'default', cardParams = {}, types = []) => {
  const defaultConfig = get(definition, relationType, get(definition, 'default'));
  const config = merge({}, defaultConfig, { cardParams }) as INxRelationshipEditorConfig;

  config.relationType = relationType;
  config.types = null;
  if (Array.isArray(types) && types.length > 0) {
    config.types = types;
  } else if (Array.isArray(config.cardParams.types) && config.cardParams.types.length > 0) {
    config.types = config.cardParams.types;
  }

  return cloneDeep(config);
};


export default definition;
